import { selectWarehouseStatePlace } from 'containers/Warehouses/warehousesSlice'
import { useReduxSelector } from 'store'
import { POST } from 'rest/request'
import { useState } from 'react'
import { api } from 'rest/urls'

type Type = 'gate' | 'gateway'

const useOpeningClosingActions = (
  placeId: string,
  actions?: warehouse.OpeningClosingActions
) => {
  const [isSending, setSending] = useState(false)
  const place = useReduxSelector(state => selectWarehouseStatePlace(state, placeId))
  const gateState = getFirstGateInThePlace(place?.gates)
  const gatewaysState = getFirstGatewayInThePlace(place?.gateways)

  const action = async <T extends Type>(_type: T, additionalBody?: object) => {
    if (isSending) return
    try {
      const action = actions?.[_type]?.open
      if (!action) throw new Error('No action')
      if (action.type === 'request' && action.method === 'POST') {
        setSending(true)
        const body = additionalBody
          ? { ...action.payload, ...additionalBody }
          : action.payload
        const response = await POST(`${api}${action.url}`, { body })
        setSending(false)
        return response

      } else {
        throw new Error('No supported action')
      }
    } catch (error) {
      setSending(false)
      console.error(error)
    }
  }

  return {
    status: {
      gateway: gatewaysState,
      gate: gateState,
    },
    isSending,
    action
  }
}

const getFirstGateInThePlace = (gates?: warehouse.ObjectStateGates) => {
  if (!gates) return
  const firstKey = Object.keys(gates)[0]
  return gates?.[firstKey]
}

const getFirstGatewayInThePlace = (gateways?: warehouse.ObjectStateGateways) => {
  if (!gateways) return
  const firstKey = Object.keys(gateways)[0]
  return gateways?.[firstKey]
}

export default useOpeningClosingActions